var Summary = require('../summary');
var _require = require('../categories'),
  DEFAULT_PAGE_SIZE = _require.DEFAULT_PAGE_SIZE,
  normalizeOffset = _require.normalizeOffset,
  normalizePageSize = _require.normalizePageSize;

/**
 * Fetch one page of listings from the Store peer.
 * public_key '' → server applies its ModTools whitelist (active listings).
 * public_key set → that seller's listings for status 'active' (default) or 'sold'.
 */
function loadListingsPage(app, mod) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$public_key = _ref.public_key,
    public_key = _ref$public_key === void 0 ? '' : _ref$public_key,
    _ref$category = _ref.category,
    category = _ref$category === void 0 ? '' : _ref$category,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    _ref$page_size = _ref.page_size,
    page_size = _ref$page_size === void 0 ? DEFAULT_PAGE_SIZE : _ref$page_size,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'active' : _ref$status;
  return new Promise(function (resolve, reject) {
    var _app$network;
    var peerKey = mod.store_public_key;
    if (!peerKey || !(app !== null && app !== void 0 && (_app$network = app.network) !== null && _app$network !== void 0 && _app$network.sendRequestAsTransaction)) {
      reject(new Error('Store peer unavailable'));
      return;
    }
    var request = {
      module: 'Store',
      public_key: String(public_key || ''),
      category: String(category || ''),
      offset: normalizeOffset(offset),
      page_size: normalizePageSize(page_size),
      status: String(status || '').toLowerCase() === 'sold' ? 'sold' : 'active'
    };
    app.network.sendRequestAsTransaction('load-listings', request, function (response) {
      if (!response || !Array.isArray(response.listings)) {
        reject(new Error('Invalid load-listings response'));
        return;
      }

      // Listing-row browse cards: do not sync into nft_id:price bucket cache
      // (distinct listings sharing a bucket must not overwrite each other).
      var listings = response.listings.map(function (data) {
        return new Summary(app, mod, data);
      }).filter(function (summary) {
        return !!summary.nft_id;
      });
      resolve({
        listings: listings,
        public_key: response.public_key || request.public_key,
        category: response.category || request.category,
        pagination: response.pagination || {
          offset: request.offset,
          page_size: request.page_size,
          total: listings.length,
          total_pages: listings.length ? 1 : 0,
          page: 1,
          has_next: false,
          has_previous: false
        }
      });
    }, peerKey);
  });
}

/**
 * Fetch a seller's sold listings (and active) from the Store peer.
 * Sold-only use; active browsing goes through loadListingsPage.
 */
function loadSellerInventory(app, mod) {
  var seller = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return new Promise(function (resolve, reject) {
    var _app$network2;
    var key = String(seller || '').trim();
    if (!key) {
      reject(new Error('Seller public key required'));
      return;
    }
    var peerKey = mod.store_public_key;
    if (!peerKey || !(app !== null && app !== void 0 && (_app$network2 = app.network) !== null && _app$network2 !== void 0 && _app$network2.sendRequestAsTransaction)) {
      reject(new Error('Store peer unavailable'));
      return;
    }
    app.network.sendRequestAsTransaction('load-seller-inventory', {
      module: 'Store',
      seller: key
    }, function (response) {
      if (!response || !Array.isArray(response.active) || !Array.isArray(response.sold)) {
        reject(new Error('Invalid load-seller-inventory response'));
        return;
      }
      var hydrate = function hydrate(data) {
        var summary = new Summary(app, mod, data);
        return summary.nft_id ? summary : null;
      };
      resolve({
        seller: response.seller || key,
        active: response.active.map(hydrate).filter(Boolean),
        sold: response.sold.map(hydrate).filter(Boolean)
      });
    }, peerKey);
  });
}
module.exports = {
  loadListingsPage: loadListingsPage,
  loadSellerInventory: loadSellerInventory
};